import 'svelte/internal/disclose-version';

FilterPane[$.FILENAME] = 'src/components/FilterPane.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations($.from_html(`<label class="opt svelte-1e6xbxo"><input type="checkbox" class="svelte-1e6xbxo"/> <span class="svelte-1e6xbxo"> </span> <em class="svelte-1e6xbxo"> </em></label>`), FilterPane[$.FILENAME], [[55, 8, [[56, 10], [61, 10], [62, 10]]]]);
var root_1 = $.add_locations($.from_html(`<label class="opt svelte-1e6xbxo"><input type="checkbox" class="svelte-1e6xbxo"/> <span class="svelte-1e6xbxo"> </span> <em class="svelte-1e6xbxo"> </em></label>`), FilterPane[$.FILENAME], [[76, 10, [[77, 12], [82, 12], [83, 12]]]]);
var root_2 = $.add_locations($.from_html(`<section data-key="city"><header class="svelte-1e6xbxo"><h2 class="svelte-1e6xbxo">Town</h2> <button type="button" class="svelte-1e6xbxo">Clear</button></header> <div class="options svelte-1e6xbxo"></div></section>`), FilterPane[$.FILENAME], [[69, 4, [[70, 6, [[71, 8], [72, 8]]], [74, 6]]]]);
var root_3 = $.add_locations($.from_html(`<label class="opt svelte-1e6xbxo"><input type="checkbox" class="svelte-1e6xbxo"/> <span class="svelte-1e6xbxo"> </span></label>`), FilterPane[$.FILENAME], [[97, 8, [[98, 10], [103, 10]]]]);
var root_4 = $.add_locations($.from_html(`<label class="opt svelte-1e6xbxo"><input type="checkbox" class="svelte-1e6xbxo"/> <span class="svelte-1e6xbxo"> </span></label>`), FilterPane[$.FILENAME], [[116, 8, [[117, 10], [122, 10]]]]);

var root_5 = $.add_locations($.from_html(`<div class="filter-bar svelte-1e6xbxo"><section data-key="cuisine"><header class="svelte-1e6xbxo"><h2 class="svelte-1e6xbxo">Cuisine</h2> <button type="button" class="svelte-1e6xbxo">Clear</button></header> <div class="options svelte-1e6xbxo"></div></section> <!> <section data-key="price"><header class="svelte-1e6xbxo"><h2 class="svelte-1e6xbxo">Price</h2> <button type="button" class="svelte-1e6xbxo">Clear</button></header> <div class="options svelte-1e6xbxo"></div></section> <section data-key="rating"><header class="svelte-1e6xbxo"><h2 class="svelte-1e6xbxo">Rating</h2> <button type="button" class="svelte-1e6xbxo">Clear</button></header> <div class="options svelte-1e6xbxo"></div></section></div>`), FilterPane[$.FILENAME], [
	[
		47,
		0,
		[
			[48, 2, [[49, 4, [[50, 6], [51, 6]]], [53, 4]]],
			[90, 2, [[91, 4, [[92, 6], [93, 6]]], [95, 4]]],
			[109, 2, [[110, 4, [[111, 6], [112, 6]]], [114, 4]]]
		]
	]
]);

const $$css = {
	hash: 'svelte-1e6xbxo',
	code: '\n  /* A row of short scrollable lists rather than a bar of controls. The lists are capped in height\n     because the vocabularies are long: forty cuisines would otherwise push everything below the\n     fold. */\n  .filter-bar.svelte-1e6xbxo {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 20px;\n    padding: 16px;\n    margin-bottom: 22px;\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n  }\n  .group.svelte-1e6xbxo { display: flex; flex-direction: column; gap: 8px; min-width: 170px; flex: 1 1 170px; border-radius: var(--radius-sm); transition: background 0.2s ease, box-shadow 0.2s ease; }\n  .group.highlight.svelte-1e6xbxo { background: var(--accent-soft); box-shadow: 0 0 0 8px var(--accent-soft); }\n  .group.narrow.svelte-1e6xbxo { min-width: 140px; flex: 0 1 150px; }\n  .group.svelte-1e6xbxo header:where(.svelte-1e6xbxo) { display: flex; align-items: baseline; gap: 8px; }\n  .group.svelte-1e6xbxo header:where(.svelte-1e6xbxo) h2:where(.svelte-1e6xbxo) {\n    font-size: 0.72rem;\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    color: var(--ink-faint);\n    margin-right: auto;\n  }\n  .group.svelte-1e6xbxo header:where(.svelte-1e6xbxo) button:where(.svelte-1e6xbxo) {\n    border: none;\n    background: none;\n    color: var(--accent);\n    font-size: 0.72rem;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n  }\n  .group.svelte-1e6xbxo header:where(.svelte-1e6xbxo) button:where(.svelte-1e6xbxo):hover { text-decoration: underline; }\n  .options.svelte-1e6xbxo {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n    max-height: 190px;\n    overflow-y: auto;\n    padding-right: 4px;\n  }\n  .opt.svelte-1e6xbxo {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.86rem;\n    padding: 3px 6px;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n  }\n  .opt.svelte-1e6xbxo:hover { background: var(--card-soft); }\n  .opt.svelte-1e6xbxo input:where(.svelte-1e6xbxo) { accent-color: var(--accent); margin: 0; cursor: pointer; flex: none; }\n  .opt.svelte-1e6xbxo span:where(.svelte-1e6xbxo) { flex: 1; }\n  .opt.svelte-1e6xbxo em:where(.svelte-1e6xbxo) { color: var(--ink-faint); font-size: 0.76rem; font-style: normal; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsdGVyUGFuZS5zdmVsdGUiLCJzb3VyY2VzIjpbIkZpbHRlclBhbmUuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQ+XG4gIC8qKlxuICAgKiBUaGUgZmFjZXQgY2hlY2tib3ggZ3JvdXBzLCBzaGFyZWQgYnkgdGhlIHNlYXJjaCBwYWdlIGFuZCB0aGUgYWRtaW4gaW5nZXN0IHJ1bm5lci5cbiAgICpcbiAgICogUHJvcC1kcml2ZW4gcmF0aGVyIHRoYW4gVVJMLWRyaXZlbiBvbiBwdXJwb3NlOiB0aGUgc2VhcmNoIHBhZ2UgdHVybnMgYSBjaGFuZ2UgaW50byBhIHF1ZXJ5XG4gICAqIHN0cmluZywgdGhlIHJ1bm5lciB0dXJucyBpdCBpbnRvIGl0cyBvd24gbG9jYWwgc3RhdGUsIGFuZCBuZWl0aGVyIHNob3VsZCBoYXZlIHRvIGtub3cgaG93IHRoZVxuICAgKiBvdGhlciBzdG9yZXMgYSBzZWxlY3Rpb24uIFRoZSBtYXJrdXAgYW5kIHRoZSBzZW1hbnRpY3Mgc3RheSBpbiBvbmUgcGxhY2UuXG4gICAqL1xuICBsZXQge1xuICAgIGZhY2V0cyA9IHsgY3Vpc2luZXM6IFtdLCBjaXRpZXM6IFtdIH0sXG4gICAgc2VsZWN0aW9uID0geyBjdWlzaW5lOiBbXSwgY2l0eTogW10sIHByaWNlOiBbXSwgcmF0aW5nOiBbXSB9LFxuICAgIC8qKiBUaGUgcnVubmVyJ3MgdG93biBpcyBpdHMgb3duIGZpZWxkLCBzbyBpdCBoaWRlcyB0aGlzIGdyb3VwLiAqL1xuICAgIHNob3dUb3ducyA9IHRydWUsXG4gICAgLyoqIEZhY2V0IGtleSB0byBmbGFzaCwgc2V0IHdoZW4gYSBjaGlwIGluIHRoZSBzZWFyY2ggYm94IHdhcyBjbGlja2VkLiAqL1xuICAgIGhpZ2hsaWdodCA9IG51bGwsXG4gICAgb25jaGFuZ2UgPSAoKSA9PiB7fSxcbiAgfSA9ICRwcm9wcygpO1xuXG4gIGNvbnN0IFBSSUNFUyA9IFsxLCAyLCAzLCA0XTtcbiAgY29uc3QgUkFUSU5HUyA9IFszLCA0LCA0LjVdO1xuXG4gIGNvbnN0IHRvd25zID0gJGRlcml2ZWQoXG4gICAgKGZhY2V0cy5jaXRpZXMgPz8gW10pLm1hcCgoZmFjZXQpID0+ICh7XG4gICAgICB2YWx1ZTogZmFjZXQudmFsdWUuc3BsaXQoXCIsXCIpWzBdLnRyaW0oKSxcbiAgICAgIGxhYmVsOiBmYWNldC52YWx1ZSxcbiAgICAgIGNvdW50OiBmYWNldC5jb3VudCxcbiAgICB9KSksXG4gICk7XG5cbiAgZnVuY3Rpb24gaXNDaGVja2VkKHNlbGVjdGVkLCB2YWx1ZSkge1xuICAgIHJldHVybiAoc2VsZWN0ZWQgPz8gW10pLnNvbWUoKGl0ZW0pID0+IGl0ZW0udG9Mb3dlckNhc2UoKSA9PT0gdmFsdWUudG9Mb3dlckNhc2UoKSk7XG4gIH1cblxuICBmdW5jdGlvbiB0b2dnbGUocGFyYW0sIHNlbGVjdGVkLCB2YWx1ZSkge1xuICAgIGNvbnN0IG5leHQgPSBpc0NoZWNrZWQoc2VsZWN0ZWQsIHZhbHVlKVxuICAgICAgPyBzZWxlY3RlZC5maWx0ZXIoKGl0ZW0pID0+IGl0ZW0udG9Mb3dlckNhc2UoKSAhPT0gdmFsdWUudG9Mb3dlckNhc2UoKSlcbiAgICAgIDogWy4uLnNlbGVjdGVkLCB2YWx1ZV07XG4gICAgb25jaGFuZ2UoeyBbcGFyYW1dOiBuZXh0IH0pO1xuICB9XG5cbiAgLy8gTm8gY2hlY2tzIGlzIFwibm8gZmlsdGVyXCIg4oCUIGV2ZXJ5IHZhbHVlIOKAlCBzbyBvbmUgQ2xlYXIgcGVyIGdyb3VwIHNheXMgYWxsIHRoZXJlIGlzIHRvIHNheS5cbiAgZnVuY3Rpb24gY2xlYXIocGFyYW0pIHtcbiAgICBvbmNoYW5nZSh7IFtwYXJhbV06IFtdIH0pO1xuICB9XG48L3NjcmlwdD5cblxuPGRpdiBjbGFzcz1cImZpbHRlci1iYXJcIj5cbiAgPHNlY3Rpb24gY2xhc3M9XCJncm91cFwiIGNsYXNzOmhpZ2hsaWdodD17aGlnaGxpZ2h0ID09PSBcImN1aXNpbmVcIn0gZGF0YS1rZXk9XCJjdWlzaW5lXCI+XG4gICAgPGhlYWRlcj5cbiAgICAgIDxoMj5DdWlzaW5lPC9oMj5cbiAgICAgIDxidXR0b24gdHlwZT1cImJ1dHRvblwiIG9uY2xpY2s9eygpID0+IGNsZWFyKFwiY3Vpc2luZVwiKX0+Q2xlYXI8L2J1dHRvbj5cbiAgICA8L2hlYWRlcj5cbiAgICA8ZGl2IGNsYXNzPVwib3B0aW9uc1wiPlxuICAgICAgeyNlYWNoIGZhY2V0cy5jdWlzaW5lcyA/PyBbXSBhcyBmYWNldCAoZmFjZXQudmFsdWUpfVxuICAgICAgICA8bGFiZWwgY2xhc3M9XCJvcHRcIj5cbiAgICAgICAgICA8aW5wdXRcbiAgICAgICAgICAgIHR5cGU9XCJjaGVja2JveFwiXG4gICAgICAgICAgICBjaGVja2VkPXtpc0NoZWNrZWQoc2VsZWN0aW9uLmN1aXNpbmUsIGZhY2V0LnZhbHVlKX1cbiAgICAgICAgICAgIG9uY2hhbmdlPXsoKSA9PiB0b2dnbGUoXCJjdWlzaW5lXCIsIHNlbGVjdGlvbi5jdWlzaW5lLCBmYWNldC52YWx1ZSl9XG4gICAgICAgICAgLz5cbiAgICAgICAgICA8c3Bhbj57ZmFjZXQudmFsdWV9PC9zcGFuPlxuICAgICAgICAgIDxlbT57ZmFjZXQuY291bnR9PC9lbT5cbiAgICAgICAgPC9sYWJlbD5cbiAgICAgIHsvZWFjaH1cbiAgICA8L2Rpdj5cbiAgPC9zZWN0aW9uPlxuXG4gIHsjaWYgc2hvd1Rvd25zfVxuICAgIDxzZWN0aW9uIGNsYXNzPVwiZ3JvdXBcIiBjbGFzczpoaWdobGlnaHQ9e2hpZ2hsaWdodCA9PT0gXCJjaXR5XCJ9IGRhdGEta2V5PVwiY2l0eVwiPlxuICAgICAgPGhlYWRlcj5cbiAgICAgICAgPGgyPlRvd248L2gyPlxuICAgICAgICA8YnV0dG9uIHR5cGU9XCJidXR0b25cIiBvbmNsaWNrPXsoKSA9PiBjbGVhcihcImNpdHlcIil9PkNsZWFyPC9idXR0b24+XG4gICAgICA8L2hlYWRlcj5cbiAgICAgIDxkaXYgY2xhc3M9XCJvcHRpb25zXCI+XG4gICAgICAgIHsjZWFjaCB0b3ducyBhcyB0b3duICh0b3duLnZhbHVlKX1cbiAgICAgICAgICA8bGFiZWwgY2xhc3M9XCJvcHRcIj5cbiAgICAgICAgICAgIDxpbnB1dFxuICAgICAgICAgICAgICB0eXBlPVwiY2hlY2tib3hcIlxuICAgICAgICAgICAgICBjaGVja2VkPXtpc0NoZWNrZWQoc2VsZWN0aW9uLmNpdHksIHRvd24udmFsdWUpfVxuICAgICAgICAgICAgICBvbmNoYW5nZT17KCkgPT4gdG9nZ2xlKFwiY2l0eVwiLCBzZWxlY3Rpb24uY2l0eSwgdG93bi52YWx1ZSl9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICAgPHNwYW4+e3Rvd24ubGFiZWx9PC9zcGFuPlxuICAgICAgICAgICAgPGVtPnt0b3duLmNvdW50fTwvZW0+XG4gICAgICAgICAgPC9sYWJlbD5cbiAgICAgICAgey9lYWNofVxuICAgICAgPC9kaXY+XG4gICAgPC9zZWN0aW9uPlxuICB7L2lmfVxuXG4gIDxzZWN0aW9uIGNsYXNzPVwiZ3JvdXAgbmFycm93XCIgY2xhc3M6aGlnaGxpZ2h0PXtoaWdobGlnaHQgPT09IFwicHJpY2VcIn0gZGF0YS1rZXk9XCJwcmljZVwiPlxuICAgIDxoZWFkZXI+XG4gICAgICA8aDI+UHJpY2U8L2gyPlxuICAgICAgPGJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgb25jbGljaz17KCkgPT4gY2xlYXIoXCJwcmljZVwiKX0+Q2xlYXI8L2J1dHRvbj5cbiAgICA8L2hlYWRlcj5cbiAgICA8ZGl2IGNsYXNzPVwib3B0aW9uc1wiPlxuICAgICAgeyNlYWNoIFBSSUNFUyBhcyBsZXZlbCAobGV2ZWwpfVxuICAgICAgICA8bGFiZWwgY2xhc3M9XCJvcHRcIj5cbiAgICAgICAgICA8aW5wdXRcbiAgICAgICAgICAgIHR5cGU9XCJjaGVja2JveFwiXG4gICAgICAgICAgICBjaGVja2VkPXsoc2VsZWN0aW9uLnByaWNlID8/IFtdKS5pbmNsdWRlcyhTdHJpbmcobGV2ZWwpKX1cbiAgICAgICAgICAgIG9uY2hhbmdlPXsoKSA9PiB0b2dnbGUoXCJwcmljZVwiLCBzZWxlY3Rpb24ucHJpY2UsIFN0cmluZyhsZXZlbCkpfVxuICAgICAgICAgIC8+XG4gICAgICAgICAgPHNwYW4+e1wiJFwiLnJlcGVhdChsZXZlbCl9IG9yIGxlc3M8L3NwYW4+XG4gICAgICAgIDwvbGFiZWw+XG4gICAgICB7L2VhY2h9XG4gICAgPC9kaXY+XG4gIDwvc2VjdGlvbj5cblxuICA8c2VjdGlvbiBjbGFzcz1cImdyb3VwIG5hcnJvd1wiIGNsYXNzOmhpZ2hsaWdodD17aGlnaGxpZ2h0ID09PSBcInJhdGluZ1wifSBkYXRhLWtleT1cInJhdGluZ1wiPlxuICAgIDxoZWFkZXI+XG4gICAgICA8aDI+UmF0aW5nPC9oMj5cbiAgICAgIDxidXR0b24gdHlwZT1cImJ1dHRvblwiIG9uY2xpY2s9eygpID0+IGNsZWFyKFwicmF0aW5nXCIpfT5DbGVhcjwvYnV0dG9uPlxuICAgIDwvaGVhZGVyPlxuICAgIDxkaXYgY2xhc3M9XCJvcHRpb25zXCI+XG4gICAgICB7I2VhY2ggUkFUSU5HUyBhcyB0aHJlc2hvbGQgKHRocmVzaG9sZCl9XG4gICAgICAgIDxsYWJlbCBjbGFzcz1cIm9wdFwiPlxuICAgICAgICAgIDxpbnB1dFxuICAgICAgICAgICAgdHlwZT1cImNoZWNrYm94XCJcbiAgICAgICAgICAgIGNoZWNrZWQ9eyhzZWxlY3Rpb24ucmF0aW5nID8/IFtdKS5pbmNsdWRlcyhTdHJpbmcodGhyZXNob2xkKSl9XG4gICAgICAgICAgICBvbmNoYW5nZT17KCkgPT4gdG9nZ2xlKFwicmF0aW5nXCIsIHNlbGVjdGlvbi5yYXRpbmcsIFN0cmluZyh0aHJlc2hvbGQpKX1cbiAgICAgICAgICAvPlxuICAgICAgICAgIDxzcGFuPnt0aHJlc2hvbGR9KyBzdGFyczwvc3Bhbj5cbiAgICAgICAgPC9sYWJlbD5cbiAgICAgIHsvZWFjaH1cbiAgICA8L2Rpdj5cbiAgPC9zZWN0aW9uPlxuPC9kaXY+XG5cbjxzdHlsZT5cbiAgLyogQSByb3cgb2Ygc2hvcnQgc2Nyb2xsYWJsZSBsaXN0cyByYXRoZXIgdGhhbiBhIGJhciBvZiBjb250cm9scy4gVGhlIGxpc3RzIGFyZSBjYXBwZWQgaW4gaGVpZ2h0XG4gICAgIGJlY2F1c2UgdGhlIHZvY2FidWxhcmllcyBhcmUgbG9uZzogZm9ydHkgY3Vpc2luZXMgd291bGQgb3RoZXJ3aXNlIHB1c2ggZXZlcnl0aGluZyBiZWxvdyB0aGVcbiAgICAgZm9sZC4gKi9cbiAgLmZpbHRlci1iYXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC13cmFwOiB3cmFwO1xuICAgIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0O1xuICAgIGdhcDogMjBweDtcbiAgICBwYWRkaW5nOiAxNnB4O1xuICAgIG1hcmdpbi1ib3R0b206IDIycHg7XG4gICAgYmFja2dyb3VuZDogdmFyKC0tY2FyZCk7XG4gICAgYm9yZGVyOiAxcHggc29saWQgdmFyKC0tbGluZSk7XG4gICAgYm9yZGVyLXJhZGl1czogdmFyKC0tcmFkaXVzKTtcbiAgfVxuICAuZ3JvdXAgeyBkaXNwbGF5OiBmbGV4OyBmbGV4LWRpcmVjdGlvbjogY29sdW1uOyBnYXA6IDhweDsgbWluLXdpZHRoOiAxNzBweDsgZmxleDogMSAxIDE3MHB4OyBib3JkZXItcmFkaXVzOiB2YXIoLS1yYWRpdXMtc20pOyB0cmFuc2l0aW9uOiBiYWNrZ3JvdW5kIDAuMnMgZWFzZSwgYm94LXNoYWRvdyAwLjJzIGVhc2U7IH1cbiAgLmdyb3VwLmhpZ2hsaWdodCB7IGJhY2tncm91bmQ6IHZhcigtLWFjY2VudC1zb2Z0KTsgYm94LXNoYWRvdzogMCAwIDAgOHB4IHZhcigtLWFjY2VudC1zb2Z0KTsgfVxuICAuZ3JvdXAubmFycm93IHsgbWluLXdpZHRoOiAxNDBweDsgZmxleDogMCAxIDE1MHB4OyB9XG4gIC5ncm91cCBoZWFkZXIgeyBkaXNwbGF5OiBmbGV4OyBhbGlnbi1pdGVtczogYmFzZWxpbmU7IGdhcDogOHB4OyB9XG4gIC5ncm91cCBoZWFkZXIgaDIge1xuICAgIGZvbnQtc2l6ZTogMC43MnJlbTtcbiAgICB0ZXh0LXRyYW5zZm9ybTogdXBwZXJjYXNlO1xuICAgIGxldHRlci1zcGFjaW5nOiAwLjA3ZW07XG4gICAgY29sb3I6IHZhcigtLWluay1mYWludCk7XG4gICAgbWFyZ2luLXJpZ2h0OiBhdXRvO1xuICB9XG4gIC5ncm91cCBoZWFkZXIgYnV0dG9uIHtcbiAgICBib3JkZXI6IG5vbmU7XG4gICAgYmFja2dyb3VuZDogbm9uZTtcbiAgICBjb2xvcjogdmFyKC0tYWNjZW50KTtcbiAgICBmb250LXNpemU6IDAuNzJyZW07XG4gICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgcGFkZGluZzogMDtcbiAgfVxuICAuZ3JvdXAgaGVhZGVyIGJ1dHRvbjpob3ZlciB7IHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lOyB9XG4gIC5vcHRpb25zIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiAxcHg7XG4gICAgbWF4LWhlaWdodDogMTkwcHg7XG4gICAgb3ZlcmZsb3cteTogYXV0bztcbiAgICBwYWRkaW5nLXJpZ2h0OiA0cHg7XG4gIH1cbiAgLm9wdCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGdhcDogOHB4O1xuICAgIGZvbnQtc2l6ZTogMC44NnJlbTtcbiAgICBwYWRkaW5nOiAzcHggNnB4O1xuICAgIGJvcmRlci1yYWRpdXM6IHZhcigtLXJhZGl1cy1zbSk7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICB9XG4gIC5vcHQ6aG92ZXIgeyBiYWNrZ3JvdW5kOiB2YXIoLS1jYXJkLXNvZnQpOyB9XG4gIC5vcHQgaW5wdXQgeyBhY2NlbnQtY29sb3I6IHZhcigtLWFjY2VudCk7IG1hcmdpbjogMDsgY3Vyc29yOiBwb2ludGVyOyBmbGV4OiBub25lOyB9XG4gIC5vcHQgc3BhbiB7IGZsZXg6IDE7IH1cbiAgLm9wdCBlbSB7IGNvbG9yOiB2YXIoLS1pbmstZmFpbnQpOyBmb250LXNpemU6IDAuNzZyZW07IGZvbnQtc3R5bGU6IG5vcm1hbDsgfVxuPC9zdHlsZT5cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBaUlBLEVBQUU7QUFDRjtBQUNBO0FBQ0EsRUFBRSwwQkFBVyxDQUFDO0FBQ2QsSUFBSSxhQUFhO0FBQ2pCLElBQUksZUFBZTtBQUNuQixJQUFJLHVCQUF1QjtBQUMzQixJQUFJLFNBQVM7QUFDYixJQUFJLGFBQWE7QUFDakIsSUFBSSxtQkFBbUI7QUFDdkIsSUFBSSx1QkFBdUI7QUFDM0IsSUFBSSw2QkFBNkI7QUFDakMsSUFBSSw0QkFBNEI7QUFDaEM7QUFDQSxFQUFFLHFCQUFNLENBQUMsRUFBRSxhQUFhLEVBQUUsc0JBQXNCLEVBQUUsUUFBUSxFQUFFLGdCQUFnQixFQUFFLGVBQWUsRUFBRSwrQkFBK0IsRUFBRSxzREFBc0Q7QUFDdEwsRUFBRSxNQUFNLHlCQUFVLENBQUMsRUFBRSw4QkFBOEIsRUFBRSx3Q0FBd0M7QUFDN0YsRUFBRSxNQUFNLHNCQUFPLENBQUMsRUFBRSxnQkFBZ0IsRUFBRSxlQUFlO0FBQ25ELEVBQUUscUJBQU0sQ0FBQyw2QkFBTSxDQUFDLEVBQUUsYUFBYSxFQUFFLHFCQUFxQixFQUFFLFFBQVE7QUFDaEUsRUFBRSxxQkFBTSxDQUFDLDZCQUFNLENBQUMseUJBQUUsQ0FBQztBQUNuQixJQUFJLGtCQUFrQjtBQUN0QixJQUFJLHlCQUF5QjtBQUM3QixJQUFJLHNCQUFzQjtBQUMxQixJQUFJLHVCQUF1QjtBQUMzQixJQUFJLGtCQUFrQjtBQUN0QjtBQUNBLEVBQUUscUJBQU0sQ0FBQyw2QkFBTSxDQUFDLDZCQUFNLENBQUM7QUFDdkIsSUFBSSxZQUFZO0FBQ2hCLElBQUksZ0JBQWdCO0FBQ3BCLElBQUksb0JBQW9CO0FBQ3hCLElBQUksa0JBQWtCO0FBQ3RCLElBQUksZ0JBQWdCO0FBQ3BCLElBQUksZUFBZTtBQUNuQixJQUFJLFVBQVU7QUFDZDtBQUNBLEVBQUUscUJBQU0sQ0FBQyw2QkFBTSxDQUFDLDZCQUFNLE1BQU0sQ0FBQyxFQUFFLDBCQUEwQjtBQUN6RCxFQUFFLHVCQUFRLENBQUM7QUFDWCxJQUFJLGFBQWE7QUFDakIsSUFBSSxzQkFBc0I7QUFDMUIsSUFBSSxRQUFRO0FBQ1osSUFBSSxpQkFBaUI7QUFDckIsSUFBSSxnQkFBZ0I7QUFDcEIsSUFBSSxrQkFBa0I7QUFDdEI7QUFDQSxFQUFFLG1CQUFJLENBQUM7QUFDUCxJQUFJLGFBQWE7QUFDakIsSUFBSSxtQkFBbUI7QUFDdkIsSUFBSSxRQUFRO0FBQ1osSUFBSSxrQkFBa0I7QUFDdEIsSUFBSSxnQkFBZ0I7QUFDcEIsSUFBSSwrQkFBK0I7QUFDbkMsSUFBSSxlQUFlO0FBQ25CO0FBQ0EsRUFBRSxtQkFBSSxNQUFNLENBQUMsRUFBRSw0QkFBNEI7QUFDM0MsRUFBRSxtQkFBSSxDQUFDLDRCQUFLLENBQUMsRUFBRSwyQkFBMkIsRUFBRSxTQUFTLEVBQUUsZUFBZSxFQUFFLFVBQVU7QUFDbEYsRUFBRSxtQkFBSSxDQUFDLDJCQUFJLENBQUMsRUFBRSxPQUFPO0FBQ3JCLEVBQUUsbUJBQUksQ0FBQyx5QkFBRSxDQUFDLEVBQUUsdUJBQXVCLEVBQUUsa0JBQWtCLEVBQUUsa0JBQWtCOyJ9 */'
};

export default function FilterPane($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, FilterPane);
	$.append_styles($$anchor, $$css);

	/**
	 * The facet checkbox groups, shared by the search page and the admin ingest runner.
	 *
	 * Prop-driven rather than URL-driven on purpose: the search page turns a change into a query
	 * string, the runner turns it into its own local state, and neither should have to know how the
	 * other stores a selection. The markup and the semantics stay in one place.
	 */
	let facets = $.prop($$props, 'facets', 19, () => ({ cuisines: [], cities: [] })),
		selection = $.prop($$props, 'selection', 19, () => ({ cuisine: [], city: [], price: [], rating: [] })),
		/** The runner's town is its own field, so it hides this group. */
		showTowns = $.prop($$props, 'showTowns', 3, true),
		/** Facet key to flash, set when a chip in the search box was clicked. */
		highlight = $.prop($$props, 'highlight', 3, null),
		onchange = $.prop($$props, 'onchange', 3, () => {});

	const PRICES = [1, 2, 3, 4];
	const RATINGS = [3, 4, 4.5];

	const towns = $.tag(
		$.derived(() => (facets().cities ?? []).map((facet) => ({
			value: facet.value.split(",")[0].trim(),
			label: facet.value,
			count: facet.count
		}))),
		'towns'
	);

	function isChecked(selected, value) {
		return (selected ?? []).some((item) => $.strict_equals(item.toLowerCase(), value.toLowerCase()));
	}

	function toggle(param, selected, value) {
		const next = isChecked(selected, value)
			? selected.filter((item) => $.strict_equals(item.toLowerCase(), value.toLowerCase(), false))
			: [...selected, value];

		onchange()({ [param]: next });
	}

	// No checks is "no filter" — every value — so one Clear per group says all there is to say.
	function clear(param) {
		onchange()({ [param]: [] });
	}

	var $$exports = { ...$.legacy_api() };
	var div = root_5();
	var section = $.child(div);
	let classes;
	var header = $.child(section);
	var button = $.sibling($.child(header), 2);

	$.reset(header);

	var div_1 = $.sibling(header, 2);

	$.add_svelte_meta(
		() => $.each(div_1, 21, () => facets().cuisines ?? [], (facet) => facet.value, ($$anchor, facet) => {
			var label = root();
			var input = $.child(label);

			$.remove_input_defaults(input);

			var span = $.sibling(input, 2);
			var text = $.child(span, true);

			$.reset(span);

			var em = $.sibling(span, 2);
			var text_1 = $.child(em, true);

			$.reset(em);
			$.reset(label);

			$.template_effect(
				($0) => {
					$.set_checked(input, $0);
					$.set_text(text, $.get(facet).value);
					$.set_text(text_1, $.get(facet).count);
				},
				[() => isChecked(selection().cuisine, $.get(facet).value)]
			);

			$.delegated('change', input, function change() {
				return toggle("cuisine", selection().cuisine, $.get(facet).value);
			});

			$.append($$anchor, label);
		}),
		'each',
		FilterPane,
		54,
		6
	);

	$.reset(div_1);
	$.reset(section);

	var node = $.sibling(section, 2);

	{
		var consequent = ($$anchor) => {
			var section_1 = root_2();
			let classes_1;
			var header_1 = $.child(section_1);
			var button_1 = $.sibling($.child(header_1), 2);

			$.reset(header_1);

			var div_2 = $.sibling(header_1, 2);

			$.add_svelte_meta(
				() => $.each(div_2, 21, () => $.get(towns), (town) => town.value, ($$anchor, town) => {
					var label_1 = root_1();
					var input_1 = $.child(label_1);

					$.remove_input_defaults(input_1);

					var span_1 = $.sibling(input_1, 2);
					var text_2 = $.child(span_1, true);

					$.reset(span_1);

					var em_1 = $.sibling(span_1, 2);
					var text_3 = $.child(em_1, true);

					$.reset(em_1);
					$.reset(label_1);

					$.template_effect(
						($0) => {
							$.set_checked(input_1, $0);
							$.set_text(text_2, $.get(town).label);
							$.set_text(text_3, $.get(town).count);
						},
						[() => isChecked(selection().city, $.get(town).value)]
					);

					$.delegated('change', input_1, function change_1() {
						return toggle("city", selection().city, $.get(town).value);
					});

					$.append($$anchor, label_1);
				}),
				'each',
				FilterPane,
				75,
				8
			);

			$.reset(div_2);
			$.reset(section_1);
			$.template_effect(() => classes_1 = $.set_class(section_1, 1, 'group svelte-1e6xbxo', null, classes_1, { highlight: $.strict_equals(highlight(), "city") }));

			$.delegated('click', button_1, function click_1() {
				return clear("city");
			});

			$.append($$anchor, section_1);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (showTowns()) $$render(consequent);
			}),
			'if',
			FilterPane,
			68,
			2
		);
	}

	var section_2 = $.sibling(node, 2);
	let classes_2;
	var header_2 = $.child(section_2);
	var button_2 = $.sibling($.child(header_2), 2);

	$.reset(header_2);

	var div_3 = $.sibling(header_2, 2);

	$.add_svelte_meta(
		() => $.each(div_3, 20, () => PRICES, (level) => level, ($$anchor, level) => {
			var label_2 = root_3();
			var input_2 = $.child(label_2);

			$.remove_input_defaults(input_2);

			var span_2 = $.sibling(input_2, 2);
			var text_4 = $.child(span_2);

			$.reset(span_2);
			$.reset(label_2);

			$.template_effect(
				($0, $1) => {
					$.set_checked(input_2, $0);
					$.set_text(text_4, `${$1 ?? ''} or less`);
				},
				[
					() => (selection().price ?? []).includes(String(level)),
					() => ("$").repeat(level)
				]
			);

			$.delegated('change', input_2, function change_2() {
				return toggle("price", selection().price, String(level));
			});

			$.append($$anchor, label_2);
		}),
		'each',
		FilterPane,
		96,
		6
	);

	$.reset(div_3);
	$.reset(section_2);

	var section_3 = $.sibling(section_2, 2);
	let classes_3;
	var header_3 = $.child(section_3);
	var button_3 = $.sibling($.child(header_3), 2);

	$.reset(header_3);

	var div_4 = $.sibling(header_3, 2);

	$.add_svelte_meta(
		() => $.each(div_4, 20, () => RATINGS, (threshold) => threshold, ($$anchor, threshold) => {
			var label_3 = root_4();
			var input_3 = $.child(label_3);

			$.remove_input_defaults(input_3);

			var span_3 = $.sibling(input_3, 2);
			var text_5 = $.child(span_3);

			$.reset(span_3);
			$.reset(label_3);

			$.template_effect(
				($0) => {
					$.set_checked(input_3, $0);
					$.set_text(text_5, `${threshold ?? ''}+ stars`);
				},
				[() => (selection().rating ?? []).includes(String(threshold))]
			);

			$.delegated('change', input_3, function change_3() {
				return toggle("rating", selection().rating, String(threshold));
			});

			$.append($$anchor, label_3);
		}),
		'each',
		FilterPane,
		115,
		6
	);

	$.reset(div_4);
	$.reset(section_3);
	$.reset(div);

	$.template_effect(() => {
		classes = $.set_class(section, 1, 'group svelte-1e6xbxo', null, classes, { highlight: $.strict_equals(highlight(), "cuisine") });
		classes_2 = $.set_class(section_2, 1, 'group narrow svelte-1e6xbxo', null, classes_2, { highlight: $.strict_equals(highlight(), "price") });
		classes_3 = $.set_class(section_3, 1, 'group narrow svelte-1e6xbxo', null, classes_3, { highlight: $.strict_equals(highlight(), "rating") });
	});

	$.delegated('click', button, function click() {
		return clear("cuisine");
	});

	$.delegated('click', button_2, function click_2() {
		return clear("price");
	});

	$.delegated('click', button_3, function click_3() {
		return clear("rating");
	});

	$.append($$anchor, div);

	return $.pop($$exports);
}

$.delegate(['click', 'change']);